export type RaceClass = "80cc" | "120cc" | "150cc";

export const DEFAULT_RACE_CLASS: RaceClass = "120cc";

export interface RaceClassProfile {
  maxSpeed: number;
  boostSpeed: number;
  acceleration: number;
  braking: number;
  steerRate: number;
  driftChargeScale: number;
  aiSkill: number;
  rubberBandScale: number;
}

export const RACE_CLASS_PROFILES: Readonly<Record<RaceClass, RaceClassProfile>> = {
  "80cc": { maxSpeed: 42, boostSpeed: 52, acceleration: 26, braking: 38, steerRate: 2.1, driftChargeScale: 0.94, aiSkill: 0.92, rubberBandScale: 1.25 },
  "120cc": { maxSpeed: 48, boostSpeed: 60, acceleration: 28, braking: 42, steerRate: 1.95, driftChargeScale: 1, aiSkill: 1, rubberBandScale: 1 },
  "150cc": { maxSpeed: 54, boostSpeed: 67, acceleration: 31, braking: 46, steerRate: 1.85, driftChargeScale: 1.08, aiSkill: 1.06, rubberBandScale: 0.75 },
};

export function normalizeRaceClass(value: unknown): RaceClass {
  return value === "80cc" || value === "150cc" ? value : DEFAULT_RACE_CLASS;
}

export function getRaceClassProfile(raceClass: RaceClass): RaceClassProfile {
  return RACE_CLASS_PROFILES[normalizeRaceClass(raceClass)];
}
